module.exports = __webpack_public_path__ + "img/audio-recording-animation.26739d99.gif";